import { Logger } from '~/helpers/logger';
import { VsfContext } from '~/composables/context';
import DOMPurify from 'isomorphic-dompurify';
import { mapValues } from "lodash-es";

export const loadCmsPageCommand = {
  execute: async (context: VsfContext, params) => {
    const queryVariables = mapValues(params, (value) => DOMPurify.sanitize(value));

    Logger.debug('[Magento]: Load versions CMS Page content', { params });

    const { data } = await context.$magento.api.versionsCmsPage({ queryVariables });

    Logger.debug('[Result]: versionsCmsPage', { data });

    return data?.['versionsCmsPage'];
  }
};